/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_home_seo_ra_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste your text to see how easy it is to read. Get the Flesch Reading Ease score, the Flesch–Kincaid grade level, and live word, sentence, and syllable counts — so you can tune your writing to your audience, all in your browser.`)
};

const es_home_seo_ra_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega tu texto para ver qué tan fácil es de leer. Obtén la puntuación Flesch Reading Ease, el nivel de grado Flesch–Kincaid, y conteos en vivo de palabras, oraciones y sílabas — para que puedas ajustar tu escritura a tu audiencia, todo en tu navegador.`)
};

const de_home_seo_ra_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie Ihren Text ein, um zu sehen, wie leicht er sich lesen lässt. Sie erhalten den Flesch Reading Ease-Wert, die Flesch–Kincaid-Klassenstufe sowie eine Live-Zählung von Wörtern, Sätzen und Silben — so können Sie Ihren Text auf Ihr Publikum abstimmen, alles direkt im Browser.`)
};

const nl_home_seo_ra_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak uw tekst om te zien hoe gemakkelijk het is om te lezen. Krijg de Flesch Reading Ease-score, het Flesch–Kincaid-graadniveau en live woord-, zin- en lettergreeptellingen — zodat u uw schrijven op uw publiek kunt afstemmen, allemaal in uw browser.`)
};

const fr_home_seo_ra_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez votre texte pour voir à quel point il est facile à lire. Obtenez le score Flesch Reading Ease, le niveau Flesch–Kincaid et des décomptes en direct des mots, phrases et syllabes — pour que vous puissiez adapter votre écriture à votre public, tout dans votre navigateur.`)
};

const it_home_seo_ra_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla il tuo testo per vedere quanto è facile leggerlo. Ottieni il punteggio Flesch Reading Ease, il livello scolastico Flesch–Kincaid e i conteggi di parole, frasi e sillabe in tempo reale — così puoi sintonizzare la tua scrittura sul tuo pubblico, tutto nel tuo browser.`)
};

const pt_br2_home_seo_ra_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole seu texto para ver o quão fácil é ler. Obtenha a pontuação Flesch Reading Ease, o nível de série Flesch–Kincaid e contagens ao vivo de palavras, sentenças e sílabas — para que você possa ajustar sua escrita ao seu público, tudo no seu navegador.`)
};

const pt_home_seo_ra_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole o seu texto para ver como é fácil ler. Obtenha a pontuação Flesch Reading Ease, o nível de escolaridade Flesch–Kincaid, e contagens em direto de palavras, frases e sílabas — para que possa ajustar a sua escrita para o seu público, tudo no seu navegador.`)
};

const ja_home_seo_ra_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストを貼り付けて、どのくらい読みやすいかを確認してください。Flesch Reading Easeスコア、Flesch–Kincaidグレードレベル、ライブ単語数、文数、音節数を取得します。ブラウザ内で執筆を読者に合わせてチューニングできます。`)
};

const zh_home_seo_ra_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴文本，查看它有多容易阅读。获取 Flesch Reading Ease 分数、Flesch–Kincaid 年级水平，以及实时的字数、句数和音节数统计——全部在浏览器中完成，帮助你根据目标读者调整写作风格。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const home_seo_ra_p1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_seo_ra_p1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("home_seo_ra_p1", locale)
	if (locale === "en") return en_home_seo_ra_p1(inputs)
	if (locale === "es") return es_home_seo_ra_p1(inputs)
	if (locale === "de") return de_home_seo_ra_p1(inputs)
	if (locale === "nl") return nl_home_seo_ra_p1(inputs)
	if (locale === "fr") return fr_home_seo_ra_p1(inputs)
	if (locale === "it") return it_home_seo_ra_p1(inputs)
	if (locale === "pt-BR") return pt_br2_home_seo_ra_p1(inputs)
	if (locale === "pt") return pt_home_seo_ra_p1(inputs)
	if (locale === "ja") return ja_home_seo_ra_p1(inputs)
	return zh_home_seo_ra_p1(inputs)
};